import { useCallback, useEffect, useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { AlertRecipientsRow } from "./AlertRecipientsRow";
import { QuietHoursPanel } from "./QuietHoursPanel";

/** Settings → Platform → Notifications: who gets each platform alert that used to go to every super admin. */
export function AdminAlertRecipientsCard() {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/admin-alerts").then(({ data }) => setD(data)).catch(() => setD(false)), []);
  useEffect(() => { load(); }, [load]);
  const nobody = d ? d.alerts.filter((a) => !a.recipients.length).length : 0;
  return (
    <Card id="admin-alert-recipients" className="max-w-3xl overflow-hidden border-slate-200 shadow-sm" data-testid="admin-alert-recipients-card">
      <div className="flex items-start gap-3 border-b border-slate-100 px-5 py-4">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-rose-50 text-rose-600"><BellRing className="h-4 w-4" /></div>
        <div className="min-w-0">
          <h3 className="font-heading text-base font-semibold text-slate-800">Admin alert recipients</h3>
          <p className="text-xs text-slate-500">Choose who gets each platform alert. These no longer go to every super admin — an empty list means nobody is told. Deactivated accounts are skipped automatically.
            {nobody > 0 && <b className="text-amber-700" data-testid="admin-alerts-nobody-count"> {nobody} alert{nobody === 1 ? " has" : "s have"} nobody yet.</b>}</p>
        </div>
      </div>
      {d === null && <Loader2 className="mx-auto my-6 h-5 w-5 animate-spin text-slate-300" />}
      {d === false && <p className="p-5 text-sm text-slate-500" data-testid="admin-alerts-error">Could not load the alert recipients.</p>}
      {d && <QuietHoursPanel key={d.quiet.updated_at || "q"} quiet={d.quiet} canEdit={d.can_edit} onSaved={load} />}
      {d && d.alerts.map((a) => <AlertRecipientsRow key={`${a.key}-${a.updated_at || ""}`} alert={a} staff={d.staff} canEdit={d.can_edit} onSaved={load} />)}
    </Card>
  );
}
